var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideMenuButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 15,
    viewBox: "0 0 32 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4164",
    "data-name": "Group 4164",
    transform: "translate(-334 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M29.333,5H2.667A2.588,2.588,0,0,1,0,2.5,2.588,2.588,0,0,1,2.667,0H29.333A2.588,2.588,0,0,1,32,2.5,2.588,2.588,0,0,1,29.333,5",
    transform: "translate(334 32)",
    fill: "#293462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M25,13H7a2.786,2.786,0,0,1-3-2.5A2.786,2.786,0,0,1,7,8H25a2.784,2.784,0,0,1,3,2.5A2.784,2.784,0,0,1,25,13",
    transform: "translate(338.001 34)",
    fill: "#293462"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenuButton);
export default __webpack_public_path__ + "static/media/SideMenuButton.d89afaf2fb28b8fc62fe0baebf2eefaf.svg";
export { ForwardRef as ReactComponent };